import _ttmlFunc from "../functions/profiles/ttmlGeneral.js";
import { XMLParser as _XMLParser } from "fast-xml-parser";
import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToPlainText = _convertToPlainText;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
const XMLParser = _XMLParser;
const ttmlFunc = _ttmlFunc;
export default {
  decode: function (input, options) {
    let events = [],
      regions = [],
      styles = [],
      region,
      style,
      timeBase = "media",
      useClockTime = false;
    const xmlToJson = new XMLParser({
      stopNodes: ["*.p"],
      numberParseOptions: {
        skipLike: /[0-9]+/
      },
      ignoreAttributes: false
    });
    let fileJson = xmlToJson.parse(input);
    //if the fileJson is missing the tt element we need to add it in
    if (!fileJson.tt) {
      fileJson = {
        tt: fileJson
      };
    }

    // console.log(fileJson);

    //console.log(options);
    timeBase = ttmlFunc.getTimeBaseValue(input) || "media";
    useClockTime = timeBase === "media" || timeBase === "clock" ? true : false;

    /* Put the region data into an array */
    if (fileJson.tt.head.layout && fileJson.tt.head.layout.region) {
      if (Array.isArray(fileJson.tt.head.layout.region)) {
        regions = fileJson.tt.head.layout.region;
      } else {
        regions = [fileJson.tt.head.layout.region];
      }
    }

    // Put the style data into an array
    if (fileJson.tt.head.styling && fileJson.tt.head.styling.style) {
      if (Array.isArray(fileJson.tt.head.styling.style)) {
        styles = fileJson.tt.head.styling.style;
      } else {
        styles = [fileJson.tt.head.styling.style];
      }
    }

    // console.log(styles);

    if (Array.isArray(fileJson.tt.body.div)) {
      fileJson.tt.body.div.forEach(paragraphGroup => {
        if (Array.isArray(paragraphGroup.p)) {
          paragraphGroup.p.forEach(paragraph => {
            if (paragraph["@_region"]) {
              region = regions.find(regionEl => {
                return regionEl["@_xml:id"] === paragraph["@_region"];
              });
            } else {
              region = false;
            }
            if (paragraph["@_style"]) {
              style = styles.find(styleEl => {
                return styleEl["@_xml:id"] === paragraph["@_style"];
              });
            } else {
              style = false;
            }
            events.push(ttmlFunc.multiLine.decodeSubtitle(paragraph, region, style, options.frameRate, options.dropFrame, useClockTime, options.window));
          });
        } else {
          if (paragraphGroup.p["@_region"]) {
            region = regions.find(regionEl => {
              return regionEl["@_xml:id"] === paragraphGroup.p["@_region"];
            });
          } else {
            region = false;
          }
          if (paragraphGroup.p["@_style"]) {
            style = styles.find(styleEl => {
              return styleEl["@_xml:id"] === paragraphGroup.p["@_style"];
            });
          } else {
            style = false;
          }
          events.push(ttmlFunc.multiLine.decodeSubtitle(paragraphGroup.p, region, style, options.frameRate, options.dropFrame, useClockTime, options.window));
        }
      });
    } else {
      if (Array.isArray(fileJson.tt.body.div.p)) {
        fileJson.tt.body.div.p.forEach(paragraph => {
          if (paragraph["@_region"]) {
            region = regions.find(regionEl => {
              return regionEl["@_xml:id"] === paragraph["@_region"];
            });
          } else {
            region = false;
          }
          if (paragraph["@_style"]) {
            style = styles.find(styleEl => {
              return styleEl["@_xml:id"] === paragraph["@_style"];
            });
          } else {
            style = false;
          }
          events.push(ttmlFunc.multiLine.decodeSubtitle(paragraph, region, style, options.frameRate, options.dropFrame, useClockTime, options.window));
        });
      } else {
        let paragraph = fileJson.tt.body.div.p;
        if (paragraph["@_region"]) {
          region = regions.find(regionEl => {
            return regionEl["@_xml:id"] === paragraph["@_region"];
          });
        } else {
          region = false;
        }
        if (paragraph["@_style"]) {
          style = styles.find(styleEl => {
            return styleEl["@_xml:id"] === paragraph["@_style"];
          });
        } else {
          style = false;
        }
        events.push(ttmlFunc.multiLine.decodeSubtitle(paragraph, region, style, options.frameRate, options.dropFrame, useClockTime, options.window));
      }
    }
    // console.log(events);
    return events;
  },
  encode: function (eventGroup, options) {
    let encodingOptions = getFormatOptions(options.formatOptions);
    let frameRateMultiplier = ttmlFunc.frameRateMultiplierMap[options.frameRate];
    let output = eol.after(`<?xml version="1.0" encoding="UTF-8"?>`);
    output += eol.after(`<tt xmlns="http://www.w3.org/ns/ttml" xmlns:tts="http://www.w3.org/ns/ttml#styling" xmlns:ttm="http://www.w3.org/ns/ttml#metadata" xmlns:ttp="http://www.w3.org/ns/ttml#parameter" xmlns:smpte="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt"  ttp:profile="http://www.w3.org/ns/ttml/profile/imsc1/text" xml:lang="${encodingOptions["Language Code"] || "en"}" ttp:frameRate="${ttmlFunc.frameRateMap[options.frameRate]}" ttp:frameRateMultiplier="${frameRateMultiplier}" ttp:timeBase="media">`);
    output += eol.after(`<head>`);
    output += eol.after(`<metadata>
        <ttm:desc>Closed Caption Converter - TTML Export</ttm:desc>
        <smpte:information xmlns:m608="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt#cea608" origin="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt#cea608" mode="Preserved" m608:channel="CC1" m608:programName="Untitled" m608:captionService="F1C1CC"/>
    </metadata>`);
    output += eol.after(`<styling><style xml:id="basic" tts:color="${encodingOptions["Font Color"] || "white"}" tts:backgroundColor="${encodingOptions["Background Color"] || "black"}" tts:fontFamily="${encodingOptions["Font Family"] || "monospace"}" tts:fontSize="${encodingOptions["Font Size (%)"] || 80}%" tts:fontWeight="${encodingOptions["Font Weight"] || "normal"}" tts:fontStyle="${encodingOptions["Font Style"] || "normal"}"/></styling>`);
    output += eol.after(`</head>`);
    output += eol.after(`<body>`);
    output += eol.after(`<div>`);

    /* EVENTS */
    eventGroup.events.forEach(event => {
      let start = encodingOptions["Timecode Format"] === "smpte" ? event.startSmpteClock : event.startMsIncode;
      let end = encodingOptions["Timecode Format"] === "smpte" ? event.endSmpteClock : event.endMsIncode;
      //console.log(event.text);
      let plainTextCustom = convertToPlainTextCustom(event.text, "\n", false, "strong", "em", "u", true);
      let plainText = convertToPlainText(event.text);
      let extents = ttmlFunc.multiLine.calcExtents(plainText, encodingOptions["Font Size (%)"]);
      let origins = ttmlFunc.multiLine.calcOrigin(plainText, event.xPos, event.yPos, encodingOptions["Font Size (%)"], options.window);
      //console.log(text);
      output += eol.after(`<p begin="${start}" end="${end}" style="basic" tts:origin='${origins}' tts:extent='${extents}' tts:textAlign="${event.alignment}">${ttmlFunc.multiLine.convertToTtml(plainTextCustom)}</p>`);
    });
    output += eol.after(`</div>`);
    output += eol.after(`</body>`);
    output += `</tt>`;
    return eol.auto(output);
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input);
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};